import { parseShellConfigFromDom } from '../parseShellConfigFromDom';
import { resolveShellConfig } from '../resolveShellConfig';
export var shellConfigOptions = {
    key: 'ShellConfig',
    isGetClientGeneratedConfigEnabled: function (featureGates) { var _a; return !!((_a = featureGates.resolveConfigGates) === null || _a === void 0 ? void 0 : _a.resolveConfigShellEnabled); },
    getClientGeneratedConfig: resolveShellConfig,
    getServerGeneratedConfig: function (context) {
        return parseShellConfigFromDom(context);
    },
};
//# sourceMappingURL=shellConfigOptions.js.map